import { render } from "./formGroupInput.vue?vue&type=template&id=665937b0"
import script from "./formGroupInput.vue?vue&type=script&lang=js"
export * from "./formGroupInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__